import React from 'react';
import reframe from 'nike-re-framejs';

export default function useLiveStreamDataLoad(visible = true) {
    React.useEffect(
        function loadLiveStreamDate() {
            if (visible) {
                reframe.dispatch(['event::liveStreams.load']);
            }
        },
        [visible]
    );
}
